import React, { useEffect } from 'react';
import DashboardLayout from 'layout/dashboardLayout';
import styles from './products.module.scss';
import pencil from '../../assets/svgs/pencil.svg';
import scratch from '../../assets/svgs/scratch.svg';
import { useHistory } from 'react-router';
import { fetchProductOfferings } from 'store/actions/products';
import { useDispatch, useSelector } from 'react-redux';
import Fetching from 'components/Fetching';
import composeHooks from 'react-hooks-compose';
import { SUPPORT_OFFICER } from 'libs';

const useForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const offerings = useSelector((state) => state.products.products.offerings);
  const loading = useSelector((state) => state.products.products.inProgress);
  const roleChecker = useSelector((state) => state.common.user);

  return {
    history,
    dispatch,
    offerings,
    loading,
    roleChecker,
  };
};

const ChooseTemplate = ({
  history,
  dispatch,
  offerings,
  loading,
  roleChecker,
}) => {
  useEffect(() => {
    dispatch(fetchProductOfferings());
  }, [dispatch]);

  useEffect(() => {
    if (roleChecker?.merchantUser?.role === SUPPORT_OFFICER) {
      history.push('/dashboard');
    }
  }, [history, roleChecker]);

  return (
    <DashboardLayout showBackIcon onGoBack={() => history.push('/products')}>
      <div className={styles.chooseBody}>
        <div className={styles.magCreate}>
          <p className={styles.chooseTitle}>Choose a Template</p>
          <p className={styles.chooseSub} style={{ marginBottom: '30px' }}>
            We want to know everything about your product
          </p>
        </div>
        {loading ? (
          <Fetching />
        ) : (
          <div className={styles.temp}>
            <div className={styles.templateDiv}>
              <div
                className={styles.dashedTemplate}
                onClick={() => history.push('/products/create')}
                data-testid="default"
              >
                <div className={styles.chooseDiv}>
                  <img src={scratch} alt="template" />
                  <div className={styles.chooseDiv2}>
                    <p className={styles.scratchTitle}>Start from scratch</p>

                    <p className={styles.chooseSub}>
                      Create your product from scratch. Drag and drop fields
                      based on your product specification. Easy!
                    </p>
                  </div>
                </div>
              </div>
              {offerings &&
                offerings.length > 0 &&
                !loading &&
                offerings.map((data, i) => {
                  return (
                    <div
                      key={i}
                      className={styles.normalTemplate}
                      onClick={() => history.push('/products/create')}
                      data-testid="template-data"
                    >
                      <div className={styles.chooseDiv}>
                        <img src={pencil} alt="template" />
                        <div className={styles.chooseDiv2}>
                          <p className={styles.scratchTitle}>{data.title}</p>

                          <p className={styles.chooseSub}>{data.description}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default composeHooks({ useForm })(ChooseTemplate);
